import { Component, OnInit } from '@angular/core';
import { SaHelpVideoService } from '../../services/SaHelpVideo.service';
import { SaHelpVideoModal } from '../../models/SaHelpVideo.model';
import { DomSanitizer } from '@angular/platform-browser';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { ErrorModel } from '../../../../shared/models/Error.model';
declare var $: any;

@Component({
  selector: 'app-sa-help-video',
  templateUrl: './sa-help-video.component.html',
  styleUrls: ['./sa-help-video.component.css']
})

export class SaHelpVideoComponent implements OnInit {
  showOverlayHelpVideo: boolean = false;
  showHelpVideoLoad: boolean = false;
  showDefineCategoryLoad: boolean = false;
  showUpdateCategoryLoad: boolean = false;
  showUpdateHelpVideoLoad: boolean = false;
  helpVideoLink: string = '';
  helpVideoCategory: string = '';
  helpVideoCategoryParent: number = 0;
  helpVideoTitle: string = '';
  helpVideoShortDescription: string = '';
  helpVideoUpdateId: string = '';
  showHelpVideoLoadMain: boolean = false;
  addVideo: SaHelpVideoModal;
  updateVideo: SaHelpVideoModal;
  displayDefineCategory;
  helpVideoLinkSave: string = '';
  helpVideoCategorySave: string = '';
  helpVideoCategoryParentSave: number = 0;
  helpVideoTitleSave: string = '';
  helpVideoShortDescriptionSave: string = '';
  helpVideoDefineCategory: string = '';
  helpVideoDefineCategorySave: string = '';
  helpVideoDefineCategoryId: string = '';
  allCategories: any[];
  orgallCategories: any[];
  displayAddVideo;
  displayUpdateVideo;
  searchTermVideo: string = '';
  totalVideosCount: number = 0;
  displayUpdateCategory;
  mainViewError = new ErrorModel();
  constructor(private _service: SaHelpVideoService, private _sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.displayAddVideo = 'none';
    this.displayUpdateVideo = 'none';
    this.displayDefineCategory = 'none';
    this.displayUpdateCategory = 'none';
    this.totalVideosCount = 0;
    this.addVideo = new SaHelpVideoModal();
    this.updateVideo = new SaHelpVideoModal();
    this.allCategories = [];
    this.orgallCategories = [];
    this.getAllVideosNCategories();
  }
  getAllVideosNCategories() {
    this.showOverlayHelpVideo = true;
    this.totalVideosCount = 0;
    this.mainViewError.display = false;
    this._service.getAllVideosNCategories().subscribe(
    (data: any[]) => {

      this.totalVideosCount = data['VideoCount'];
      this.allCategories = data['videoNCategories'];
      this.orgallCategories = data['videoNCategories'];
      this.orgallCategories.forEach(element => {
        element['videos'].forEach(element1 => {
          const url1 = this._sanitizer.bypassSecurityTrustResourceUrl(element1.url) as string;
          element1.urlShow = url1;
        });
      });
      this.allCategories.forEach(element => {
        element['videos'].forEach(element1 => {
          const url = this._sanitizer.bypassSecurityTrustResourceUrl(element1.url) as string;
          element1.urlShow = url;
        });
      });
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;

    }).add(() => {
      this.showOverlayHelpVideo = false;
      this.showHelpVideoLoadMain = false;
    });
  }

  getFilteredList(selectedHelp) {
    if (selectedHelp == '-') {
      this.allCategories = this.orgallCategories;
    } else {
      this.allCategories = this.orgallCategories.filter(category => category.id == selectedHelp);
    }
  }

  cancelUpdateDefineCategory() {
    this.helpVideoDefineCategoryId = '';
    this.helpVideoDefineCategory = '';
    this.displayUpdateCategory = 'none';
  }

  editCategory(categoryName, categoryId) {
    this.helpVideoDefineCategoryId = categoryId;
    this.helpVideoDefineCategory = categoryName;
    this.displayUpdateCategory = 'block';

  }

  alertForCategory() {
    setTimeout(() => {
      this.helpVideoDefineCategorySave = '';
      this.helpVideoDefineCategoryId = '';
      this.showHelpVideoLoadMain = true;
      this.getAllVideosNCategories();
    }, 2000);
  }


  categoryAction(categoryName, type) {
    if (categoryName == '' || categoryName == null || categoryName == undefined) {
      AlertMessages.Show('Warning', 'Please Enter Category Name', AlertType.Warning);
    } else {
      type ? this.showDefineCategoryLoad = true : this.showUpdateCategoryLoad = true;
      this._service.addCategory(this.helpVideoDefineCategoryId, categoryName).subscribe(
      (data) => {
          type ? this.displayDefineCategory = 'none' : this.displayUpdateCategory = 'none';
          this.alertForCategory();
          type ? AlertMessages.Show('Success', 'Category Created Successfully', AlertType.Success) : AlertMessages.Show('Success', 'Category Updated Successfully', AlertType.Success);
      },
      (error) => {
        AlertMessages.Show('Failed', 'Category not created', AlertType.Error);
      }).add(() => {
        type ? this.showDefineCategoryLoad = false : this.showUpdateCategoryLoad = false;
      });
    }
  }

  addVideoClick(helpvLinkSave, helpVideoCategorySave, helpVideoTypeSave, helpVideoTitleSave, helpVideosDescSave) {

    if (helpvLinkSave == '' || helpvLinkSave == null || helpvLinkSave == undefined || helpVideoCategorySave == '' || helpVideoCategorySave == null || helpVideoCategorySave == undefined || helpVideoTitleSave == '' || helpVideoTitleSave == null || helpVideoTitleSave == undefined || helpVideosDescSave == '' || helpVideosDescSave == null || helpVideosDescSave == undefined) {
      AlertMessages.Show('Warning', 'Please Fill all Fields!!!', AlertType.Warning);
    } else {
      this.addVideo.url = helpvLinkSave;
      this.addVideo.description = helpVideosDescSave;
      this.addVideo.title = helpVideoTitleSave;
      this.addVideo.categoryId = helpVideoCategorySave;
      this.addVideo.videoType = helpVideoTypeSave;
      this.showHelpVideoLoad = true;
      this._service.addVideo(this.addVideo).subscribe(
      (data) => {
          this.alertCloseSave();
          AlertMessages.Show('Success', 'Video Added Successfully', AlertType.Success);
          this.displayAddVideo = 'none';
      },
      (error) => {
          AlertMessages.Show('Failed', 'Video not added', AlertType.Error);

      }).add(() => {
        this.showHelpVideoLoad = false;
      });
    }
  }

  alertCloseSave() {
    setTimeout(() => {
      this.cancelVideo();
      this.showHelpVideoLoadMain = true;
      this.getAllVideosNCategories();
    }, 2000);
  }

  editVideo(evt) {
    this.helpVideoLink = evt.url;
    this.helpVideoCategory = evt.catId;
    this.helpVideoCategoryParent = evt.videoType;
    this.helpVideoTitle = evt.title;
    this.helpVideoShortDescription = evt.description;
    this.helpVideoUpdateId = evt.id;
  }

  deleteHelpVideo(id) {
    this._service.deleteHelpVideo(id).subscribe(
    (data) => {
        this.alertCloseDeleteVideo();
        AlertMessages.Show('Success', 'Video Deleted Successfully', AlertType.Success);
    },
    (error) => {
        AlertMessages.Show('Failed', 'Video Not Deleted!', AlertType.Error);
    });
  }


  deleteVideoCategory(id) {
    this._service.deleteVideoCategory(id).subscribe(
    (data) => {
      this.alertCloseDeleteCategory();
      AlertMessages.Show('Success', 'Category Deleted Successfully', AlertType.Success);
    },
    (error) => {
        AlertMessages.Show('Failed', 'Category Not Deleted!', AlertType.Error);
    });
  }

  alertCloseDeleteVideo() {
    setTimeout(() => {
      this.showHelpVideoLoadMain = true;
      this.getAllVideosNCategories();
    }, 2000);
  }

  alertCloseDeleteCategory() {
    setTimeout(() => {
      this.showHelpVideoLoadMain = true;
      this.getAllVideosNCategories();
    }, 2000);
  }

  updateVideoClick(helpVideoLink, helpVideoCategory, helpVideoType, helpVideoTitle, helpVideosDesc) {

    if (helpVideoLink == '' || helpVideoLink == null || helpVideoLink == undefined || helpVideoCategory == '' || helpVideoCategory == null || helpVideoCategory == undefined || helpVideoType == '' || helpVideoType == null || helpVideoType == undefined || helpVideoTitle == '' || helpVideoTitle == null || helpVideosDesc == undefined || helpVideosDesc == '' || helpVideosDesc == null || helpVideoTitle == undefined) {
      AlertMessages.Show('Warning', 'Please Fill all Fields!!!', AlertType.Warning);
    } else {
      this.showUpdateHelpVideoLoad = true;
      this.updateVideo.id = this.helpVideoUpdateId;
      this.updateVideo.url = helpVideoLink;
      this.updateVideo.description = helpVideosDesc;
      this.updateVideo.title = helpVideoTitle;
      this.updateVideo.categoryId = helpVideoCategory;
      this.updateVideo.videoType = helpVideoType;
      this._service.addVideo(this.updateVideo).subscribe(
      (data) => {
          this.displayUpdateVideo = 'none';
          this.alertCloseupdate();
          AlertMessages.Show('Success', 'Video Updated Successfully', AlertType.Success);
      },
      (error) => {
        AlertMessages.Show('Failed', 'Video not Updated', AlertType.Error);
      }).add(() => {
        this.showUpdateHelpVideoLoad = false;
      });
    }
  }

  alertCloseupdate() {
    setTimeout(() => {
      this.cancelUpdateVideo();
      this.showHelpVideoLoadMain = true;
      this.getAllVideosNCategories();
    }, 2000);
  }


  cancelUpdateVideo() {
    this.displayUpdateVideo = 'none';
    this.helpVideoLink = '';
    this.helpVideoCategory = '';
    this.helpVideoCategoryParent = 0;
    this.helpVideoTitle = '';
    this.helpVideoShortDescription = '';
    this.helpVideoUpdateId = '';
    this.updateVideo = new SaHelpVideoModal();

  }

  cancelDefineCategory() {
    this.displayDefineCategory = 'none';
    this.helpVideoDefineCategorySave = '';
    this.helpVideoDefineCategoryId = '';

  }

  cancelVideo() {
    this.displayAddVideo = 'none';
    this.helpVideoLinkSave = '';
    this.helpVideoCategorySave = '';
    this.helpVideoCategoryParentSave = 0;
    this.helpVideoTitleSave = '';
    this.helpVideoShortDescriptionSave = '';
    this.addVideo = new SaHelpVideoModal();

  }

  addVideoOpen() {
    this.displayAddVideo = 'block';
  }

  updateVideoOpen() {
    this.displayUpdateVideo = 'block';
  }

  defineCategoryOpen() {
    this.displayDefineCategory = 'block';
  }

}
